var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWomanbasıccırcle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.51 25.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#706f6f",
    strokeWidth: 0,
    d: "M25.51,12.76c0,7.05-5.71,12.76-12.76,12.76S0,19.8,0,12.76,5.71,0,12.76,0s12.76,5.71,12.76,12.76"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanbasıccırcle);
export default __webpack_public_path__ + "static/media/WOMANBASICCIRCLE.52a8eb8d955ef08f0c2fa09eb89bcddd.svg";
export { ForwardRef as ReactComponent };